<div class="grid">
  <input hidden
    #fileInput
    type="file"
    ng2FileSelect
    [uploader]="imageUploader"
    tabindex="-1"
    accept="image/*" />
  <div class="grid__unit s-4-4 m-12-12 l-8-12 l-push-left-1-12">
    <section class="richText">
      <h1>{{ 'UPLOAD-PAGE.TITLE' | translate }}</h1>
      <app-error [show]="errorDetails.show"
        [textOrKey]="errorDetails.textOrKey">
      </app-error>
      <p>{{ 'UPLOAD-PAGE.INFO' | translate }}</p>
    </section>
  </div>
</div>

<div class="grid">

  <div class="grid__unit s-4-4 m-5-12 l-3-12 l-push-left-1-12">
    <div class="imageContainer"
      [ngStyle]="{ backgroundColor: (imageState | async) ? '#fff' : '#e6e6e9' }">
      <img *ngIf="(imageState | async) && !(isUploading | async)"
        [src]="'data:image/jpg;base64,'+ (imageState | async).imageAsBase64"
        alt="photo"
        class="usabilla-dont-show" />
      <div *ngIf="(isUploading | async)"
        class="basicLoader"></div>
    </div>
    <button (click)="fileInput.click()"
      [relay42]="{ name: 'kies-foto-knop' }"
      class="button button--fullWidth button-choose-image needsclick">{{ 'GENERAL.BUTTON.IMAGE-CHOOSE' | translate }}
    </button>
  </div>

  <div class="grid__unit l-6-12 s-4-4 m-5-12">

    <ng-container *ngIf="!(imageState | async)">

      <ng-container *ngIf="imageInvalid">
        <p class="inlineNotification inlineNotification--alert">
          <span class="inlineNotification__text">
            <i class="icon icon--alert icon--nsRed icon--inline inlineNotification__icon"></i>
            {{ 'UPLOAD-PAGE.ERROR.IMAGE-INVALID-TITLE' | translate }}
          </span>
        </p>
        <ul>
          <li *ngIf="!failingMetrics">{{ 'UPLOAD-PAGE.ERROR.IMAGE-INVALID-DEFAULT' | translate }}</li>
          <li *ngFor="let metric of failingMetrics">{{metric.metricMessage}}</li>
        </ul>
      </ng-container>

      <ng-container *ngIf="!imageInvalid">
        <p>{{ 'UPLOAD-PAGE.IMAGE-REQUIREMENTS-INFO' | translate }}</p>
        <div class="richText richText--usp">
          <ul>
            <li *ngFor="let requirement of imageRequirements | async">{{ requirement }}</li>
          </ul>
        </div>
      </ng-container>

    </ng-container>

    <ng-container *ngIf="(imageState | async)">
      <p>{{ 'UPLOAD-PAGE.IMAGE-VALID' | translate }}</p>
      <p>{{ 'UPLOAD-PAGE.IMAGE-CHOOSE' | translate }}</p>
      <div class="checkbox">
        <input [relay42]="{ name: 'foto-opslaan-checkbox' }"
          [(ngModel)]="savePermission"
          (ngModelChange)="updateSavePermission()"
          type="checkbox"
          class="checkbox__input"
          id="savePermission">
        <label class="checkbox__label"
          for="savePermission"
          tabindex="-1">
          {{ 'UPLOAD-PAGE.IMAGE-PERMISSION' | translate }}
        </label>
      </div>
    </ng-container>

  </div>

</div>

<div class="grid">
  <div class="grid__unit s-4-4 m-12-12 l-10-12 l-push-left-1-12">
    <div class="actionBar actionBar--atArticleBottom">
      <div class="actionBar__container actionBar__container--right">
        <div *ngIf="isLoading"
          class="basicLoader"></div>
        <button *ngIf="!isLoading"
          id="confirmButton"
          [relay42]="{ name: 'verzenden-knop' }"
          [disabled]="!(imageState | async)"
          (click)="confirm()"
          class="button button--arrowRight button--secondary actionBar__item">
          {{ 'GENERAL.BUTTON.SEND' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
